import Vue from "vue"
import config from "../../config"
import util from './util'

export default {
  getAll(params = {}) {
    return Vue.http
      .get(config.apiBaseUrl + "/zepplin/coupons", util.makeRequestConfig(params))
      .then((response) => response.json())
  },

  getInformation(params = {}, id) {
    return Vue.http
      .get(config.apiBaseUrl + "/zepplin/coupons/" + id, util.makeRequestConfig(params))
      .then((response) => response.json())
  },

  store(params = {}, body) {
    return Vue.http
      .post(config.apiBaseUrl + "/zepplin/coupons", body, util.makeRequestConfig(params))
      .then((response) => response.json())
  },

  update(params = {}, id, body) {
    console.log(body);
    return Vue.http
      .patch(config.apiBaseUrl + "/zepplin/coupons/" + id, body, util.makeRequestConfig(params))
      .then((response) => response)
  },

  delete(params = {}, id) {
    return Vue.http
      .delete(config.apiBaseUrl + "/zepplin/coupons/" + id, util.makeRequestConfig(params))
      .then((response) => response)
  },
};
